import { ICountry } from './i-country';
import { IProduct } from './i-product';
import { EntityType } from '@boma/shared/entities';
import { ILocationSimple } from '@boma/supplier-portal/shared/entities';

//TODO Add rest of the fields when needed they are already being returned.
export interface IOrder {
  id: string;
  reference: string;
  orderDate: Date | string;
  status: string;
  charges: IOrderCharge[];
  events: IOrderEvent[];
  batchId: string;
  entity: IOrderEntityDetailed;
  deliveryHandshake: IOrderDeliveryHandshake;
  country: ICountry;
  receivingLocation: IOrderLocation;
  supplyingLocation: IOrderLocation;
}

export interface IOrderCharge {
  id: string;
  type: string;
  status: string;
  total: number;
  totalVat: number;
  totalWithoutVat: number;
  items: IOrderChargeItem[];
  events: IOrderChargeEvent[];
}

export interface IOrderChargeEvent {
  type: string;
  createdAt: Date;
}

export interface IOrderChargeItem {
  price: number;
  taxRate: number;
  quantity: number;
  product: IProduct;
}

export interface IOrderDeliveryHandshake {
  acceptedBy: IEdBy;
  deliveredBy: IEdBy;
}

export interface IEdBy {
  id: string;
  firstName: string;
  surname: string;
}

export interface IOrderEntity {
  id: string;
  name: string;
  type: string;
}

// Replaced IOrderEntity... too much detail here we should make a new API endpoint
export interface IOrderEntityDetailed {
  id: string;
  name: string;
  type: EntityType;
  registered: true;
  sector: string;
  registeredName: string;
  tradingName: string;
  registrationNumber: string;
  taxNumber: string;
  contactNumber: string;
  physicalAddressLineOne: string;
  physicalAddressLineTwo: string;
  physicalAddressCity: string;
  postalAddressLineOne: string;
  postalAddressLineTwo: string;
  postalAddressCity: string;
  postalAddressPostalCode: string;
  websiteAddress: string;
  active: true;
  notes: string;
  isAllowedToPurchaseOnCredit: boolean;
  locations: ILocationSimple;
}

export interface IOrderEvent {
  id: string;
  stockEventId: string;
  type: string;
  comment: string;
  createdAt: Date;
}

export interface IOrderLocation {
  id: string;
  name: string;
  point: IOrderLocationPoint;
  openingTime: string;
  closingTime: string;
  contactPersonName: string;
  contactPersonNumber: string;
}

export interface IOrderLocationPoint {
  type: string;
  coordinates: number[];
}
